import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import { marketingColors as C } from '../../theme_landing_page';

export interface Crumb {
  label: string;
  to?: string;
}

const Breadcrumbs: React.FC<{ items: Crumb[]; maxWidth?: number }> = ({ items, maxWidth = 760 }) => (
  <Box sx={{ padding: { xs: '100px 24px 0', md: '110px 52px 0' } }}>
    <Box sx={{ maxWidth, margin: '0 auto', display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', fontSize: 13, color: C.muted }}>
      {items.map((item, i) => (
        <React.Fragment key={item.label + i}>
          {i > 0 && <span>/</span>}
          {item.to ? (
            <RouterLink to={item.to} style={{ color: C.muted }}>
              {item.label}
            </RouterLink>
          ) : (
            <Box component="span" sx={{ color: C.ink }}>
              {item.label}
            </Box>
          )}
        </React.Fragment>
      ))}
    </Box>
  </Box>
);

export default Breadcrumbs;
